var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlayer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x9C Icon / Bold/UserPlus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector",
    d: "M19.125 12.75H22.875",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_2",
    d: "M20.9995 10.875V14.625",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_3",
    d: "M10.125 15C13.2316 15 15.75 12.4816 15.75 9.37498C15.75 6.26838 13.2316 3.74998 10.125 3.74998C7.0184 3.74998 4.5 6.26838 4.5 9.37498C4.5 12.4816 7.0184 15 10.125 15Z",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_4",
    d: "M2.08105 18.75C3.06661 17.5754 4.29746 16.6308 5.68711 15.9828C7.07676 15.3347 8.59148 14.9989 10.1248 14.9989C11.6581 14.9989 13.1728 15.3347 14.5625 15.9828C15.9521 16.6308 17.183 17.5754 18.1686 18.75",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlayer);
export default __webpack_public_path__ + "static/media/add-player.614c33d80fa5ce0ba2ca4405bdf2ca62.svg";
export { ForwardRef as ReactComponent };